export default __webpack_public_path__ + "cffeb1692d369357f3640e32a9cae0ba.png";